import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';

export const ProjectBreadcrumbs = ({ children, businessData }) => {
  // base site breadcrumbs
  const globals = useContext(GlobalContext);

  return (
    <div className="sb-main-breadcrumbs">
      <ul className="sb-flex">
        {globals.visible.projectsView && (
          <li className="sb-flex">
            <Link to={`/dashboard/projects`}>Projects</Link>
            <ChevronRightIcon />
          </li>
        )}
        <li className="sb-flex">
          {!businessData && <span>...</span>}
          {businessData && (
            <Link to={`/dashboard/projects/${businessData.id}`}>
              {businessData.business_name}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        {children}
      </ul>
    </div>
  );
};
